import Radio from "backbone.radio";

/**
 * This channel's purpose is for communication between interface components
 * example: do something when a slide-panel is closed
 */

export default Radio.channel("interface");
